<style lang="scss">
.zoezi-trainingcard-shop {
    .product-price {
        font-size: 1.25em;
    }

    .multisite-selection {
        font-size: 1.25em;
    }
}
.v-image.blur-img > .v-image__image{
    filter:blur(30px) !important;
    opacity:.4;
    transform:scale(1.2);
}
.v-card__title{
    word-break: normal;
}
.card-limit-title {
    overflow: hidden;
    height: 6em;
    margin-bottom: 0.5em;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

</style>

<template>
    <div v-if="productsLoaded">
        <v-row v-if="hasMultiSites && showSiteFilter && !globalSiteSetting" @click="sitesMenuOpen = true">
            <v-col cols=12>
                <v-sheet color="primary" rounded class="primarytext--text multisite-selection pa-2">
                    <div class="d-flex">
                        <div class="flex-grow-1"><v-icon color="primarytext">mdi-map-marker-star-outline</v-icon><span>Visar utbud hos</span></div>

                        <div v-if="onlyShowOneSite">
                            {{$translate($store.state.settings.sites.find(x => x.id == selectedSiteId).name)}}
                        </div>

                        <v-menu v-else v-model="sitesMenuOpen">
                            <template v-slot:activator="{ on }">
                                <div v-on="on" class="z-clickable">{{$translate($store.state.settings.sites.find(x => x.id == selectedSiteId).name)}} <v-icon color="primarytext">mdi-chevron-down</v-icon></div>
                            </template>

                            <v-list>
                                <v-list-item class="z-clickable" v-for="site in selectableSites" :key="site.id" @click="setSite(site)">{{$translate(site.name)}}</v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>

        <v-row v-if="$store.state.settings">
            <v-col cols=12>
                <webshop-categories-level
                    v-for="(categories, index) in categoryLevels"
                    :levelHasVisibleParent="index > 0"
                    :categories="categories"
                    :key="categoryLevelKey(categories)"
                    @selected="categorySelected($event)"
                />
            </v-col>
        </v-row>
        <v-row v-if="showTagsFilter">
            <v-col cols=12>
                <v-chip
                    v-for="tag in availableTags"
                    :key="tag.id"
                    :outlined="!tagsFilter.includes(tag.id)"
                    :close="tagsFilter.includes(tag.id)"
                    color="primary"
                    label
                    class="mr-2 mb-2"
                    @click="toggleTagFilter(tag.id)"
                    @click:close="toggleTagFilter(tag.id)"
                >
                    {{ tag.name }}
                </v-chip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="6" class="text--secondary d-flex align-center mb-2">
                <div v-if="showNumberOfItems">{{selectedText}} - {{filteredProducts.length}} {{$translate('pcs')}}</div>
            </v-col>
            <v-col cols="12" sm="6">
                <v-row class="d-flex justify-space-between" v-if="searchQuery || filteredProducts.length > showSearchIfNumItems">
                    <v-col cols="8" class="pr-1">
                        <v-text-field
                            v-if="showSearch"
                            v-model="searchQuery"
                            :label="$translate('Search')"
                            @input="searchQuery = $event ? $event.toLowerCase() : ''"
                            prepend-inner-icon="mdi-magnify"
                            clearable
                        />
                    </v-col>
                    <v-col cols="4" class="pl-1">
                        <v-select
                            v-if="showSortOrder"
                            v-model="currentSortOrder"
                            :items="sortOptions"
                            :label="$translate('Sort by')"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row>
            <v-col v-for="product in sortedProducts" :key="product.id" cols="12" sm="6" md="4" lg="3">
                <v-hover v-slot="{hover}">
                    <v-card :class="['d-flex', 'fill-height', 'flex-column', hover ? 'elevation-16' : 'elevation-2']" style="cursor: pointer; height: fit-content;" @click="productClick(product)" :ripple="false">

                        <v-auto-img v-if="!cropImages" :src="product.imagekey ? product.imagekey : undefined" position="center center" :ar="3/2" height="50%" class="blur-img py-2 align-center">
                            <v-auto-img contain :src="product.imagekey ? product.imagekey : undefined" position="center center" :ar="3/2">
                                <v-avatar v-if="product.sites && product.sites.length > 1" class="ma-2" style="float: right" color="rgba(0,0,0,0.5)" size="30"><v-icon color="white">mdi-map-marker-star-outline</v-icon></v-avatar>
                            </v-auto-img>
                        </v-auto-img>

                        <v-auto-img v-else :src="product.imagekey ? product.imagekey : undefined" position="center center" :ar="3/2">
                            <v-avatar v-if="product.sites && product.sites.length > 1" class="ma-2" style="float: right" color="rgba(0,0,0,0.5)" size="30"><v-icon color="white">mdi-map-marker-star-outline</v-icon></v-avatar>
                        </v-auto-img>

                        <div class="grow">
                            <v-card-title class="card-limit-title">{{product.name}}</v-card-title>

                            <div class="pt-0 d-flex px-2">
                                <div class="flex-grow-1">
                                    <template v-if="product.trainingsessions"><v-icon small color="primary">mdi-ticket</v-icon> {{product.trainingsessions}} {{$translate('Punch tickets').toLowerCase()}}</template>

                                    <template v-else-if="product.validTime">
                                        <template v-if="product.membership">
                                            <v-icon small color="primary">{{ product.auto ? "mdi-update" : "mdi-calendar-clock" }}</v-icon>
                                            <template v-if="!product.validFromDate">
                                                {{product.validTime}} {{$translate(product.validType + (product.validTime === 1 ? '' : 's')).toLowerCase()}}
                                            </template>
                                            <template v-else>
                                                <template>{{ isMembershipFrom0101(product) ? $translate('for').capitalize() + " " + new Date().getFullYear() : " " + $translate('To') + " " + calculateAndFormatEndDate(product.validFromDate) }}</template>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <v-icon small color="primary">mdi-calendar-clock</v-icon>
                                            {{product.validTime}} {{$translate(product.validType + (product.validTime === 1 ? '' : 's')).toLowerCase()}}
                                        </template>
                                    </template>

                                    <template v-else-if="needsToChooseVariant(product)">
                                        {{product.variants.length}} {{$translate('variants')}}
                                    </template>
                                </div>
                                <div v-if="!product.payWhatYouWant">
                                    <span class="primary--text product-price">{{product.price | price}}</span>
                                    <span v-if="product.priceType && product.priceType != 'OneTime'">
                                        /{{$translate(product.priceType).toLowerCase()}}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <v-card-actions>
                            <v-btn block color="primary" class="zoezi-button-thin" @click.stop="buyClick(product)">{{$translate('Buy')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-hover>
            </v-col>
        </v-row>

        <training-card-product-dialog
            v-if="showingProduct"
            v-model="showingProduct"
            :product="showingProduct"
            :basket="checkoutItems"
            :site-id="selectedSiteId"
            :cropImage="cropImages"
            @buy="buyFromDialog"
        />

        <v-dialog
            v-model="switchSiteDialog.show"
            max-width="500"
        >
            <v-card v-if="switchSiteDialog.show">
                <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                    {{$translate('Change store')}}
                    <v-spacer />
                    <v-btn icon @click="switchSiteDialog.show = false" ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="mt-2">
                    <p>{{$translate('You are currently shopping in the store for')}} <span class="font-weight-bold">{{switchSiteDialog.fromSite.name}}</span>. {{$translate('If you switch to')}} <span class="font-weight-bold">{{switchSiteDialog.site.name}}</span> {{$translate('the following items will disappear from your shopping cart')}}:</p>

                    <div v-for="missing in switchSiteDialog.missing" :key="missing.product.id">
                        <v-icon color="error">mdi-cancel</v-icon>
                        <span class="font-weight-bold ml-2">{{missing.product.name}}</span>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" outlined @click="forceSetSite(); switchSiteDialog.show = false" class="zoezi-button-thin">{{$translate('Change store')}}</v-btn>
                    <v-btn color="primary" @click="switchSiteDialog.show = false" class="zoezi-button-thin">{{$translate('Continue shopping')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
    <div v-else class="text-center">
        {{$translate('Loading...')}} <v-progress-circular indeterminate color="primary" />
    </div>
</template>

<script>
import WebshopCategoriesLevel from './WebshopCategoriesLevel.vue';
import TrainingCardProductDialog from '../components/TrainingCardProductDialog.vue'
import { getStockForProduct,makeValidPathFromTitle } from '../util';
import * as Sentry from '@sentry/browser';

export default {
    name: 'zoezi-shop',

    zoezi: {
        title: 'Shop',
        icon: 'mdi-cart-outline',
        addon: 'WebShop',
        getDefaultStyle: () => ({
            pageParams: [
                {
                    id: 'p',
                    prop: 'showProductTitle'
                }
            ]
        })
    },

    props: {
        onlyShowCategories: {
            title: 'Filter by categories',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return window.$zoeziapi.get('/api/public/settings/get').then(settings => {
                        return settings.webshopcategories.filter(c => !c.parent_id && !c.removed).sort((a,b) => a.name.localeCompare(b.name));
                    });
                },
                text: 'name',
                value: 'id',
                multiple: true
            },
            default: () => []
        },
        tagsFilter: {
            title: 'Filter by tags',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return window.$zoeziapi.get('/api/systemtag/get').then(all => {
                        return all;
                    });
                },
                text: 'name',
                value: 'id',
                multiple: true,
                placeholder: 'Show all tags'
            },
            default: () => []
        },
        initialSortOrder: {
            title: 'Sort order',
            type: String,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return [
                        { id: 'name-asc', name: 'Name (A-Z)' },
                        { id: 'name-desc', name: 'Name (Z-A)' },
                        { id: 'price-asc', name: 'Price (Lowest to Highest)' },
                        { id: 'price-desc', name: 'Price (Highest to Lowest)' },
                        { id: 'stock-desc', name: 'Stock (Highest to Lowest)' }
                    ].map(x => ({...x, name: window.$translate(x.name)}));
                },
                text: 'name',
                value: 'id',
                multiple: false
            },
            default: () => 'name-asc'
        },
        showTagsFilter: {
            title: 'Show tags filter',
            type: Boolean,
            default: false
        },
        showSortOrder: {
            title: 'Show sort order',
            type: Boolean,
            default: true
        },
        showSearch: {
            title: 'Show search',
            type: Boolean,
            default: true
        },
        showSearchIfNumItems: {
            title: 'Show search only if number of items is greater than',
            type: Number,
            default: 6
        },
        showNumberOfItems: {
            title: 'Show number of items',
            type: Boolean,
            default: true
        },
        globalSiteSetting: {
            title: 'Filter by globally selected site',
            type: Boolean,
            default: true
        },
        onlyShowSites: {
            title: 'Filter by site',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return window.$zoeziapi.get('/api/public/settings/get').then(settings => {
                        return settings.sites.sort((a,b) => a.name.localeCompare(b.name));
                    });
                },
                text: 'name',
                value: 'id',
                multiple: true,
                placeholder: 'Show all sites',
                visible: '!globalSiteSetting'
            },
            default: () => []
        },
        showSiteFilter: {
            title: 'Show site filter',
            type: Boolean,
            default: false,
            visible: '!globalSiteSetting'
        },
        forceInfoDialog: {
            title: 'Always show product information dialog',
            type: Boolean,
            default: false
        },
        cartName: {
            title: 'Name of shopping cart',
            type: String,
            default: '',
            typeinfo: {
                placeholder: 'Use the standard shopping cart'
            }
        },
        cropImages: {
            title: 'Crop images towards the center (3:2)',
            type: Boolean,
            default: true
        },
        showProductId: {
            title: 'Show product - ID',
            type: Number
        },
        showProductTitle: {
            title: 'Show product - name',
            type: String
        },
        selectedCategoryId: {
            title: 'Selected category - ID',
            type: Number
        },
        selectedCategoryTitle: {
            title: 'Selected category - name',
            type: String
        }
    },

    components: {
        WebshopCategoriesLevel,
        TrainingCardProductDialog
    },

    data: () => ({
        unsubscribe: null,
        products: [],
        productsLoaded: false,
        selectedSiteId: 1,
        showingProduct: null,
        showCheckout: false,
        almostdone: false,
        checkoutLoading: false,
        sitesMenuOpen: false,
        switchSiteDialog: {
            show: false,
            site: null,
            missing: []
        },
        selectedCategory: null,
        searchQuery: '',
        currentSortOrder: 'name-asc', // Default sort
        sortOptions: [
            { text: window.$translate('Name (A-Z)'), value: 'name-asc' },
            { text: window.$translate('Name (Z-A)'), value: 'name-desc' },
            { text: window.$translate('Price (Lowest to Highest)'), value: 'price-asc' },
            { text: window.$translate('Price (Highest to Lowest)'), value: 'price-desc' },
            { text: window.$translate('Stock (Highest to Lowest)'), value: 'stock-desc' },
        ]
    }),

    watch: {
        '$store.state.selectedSiteId': {
            immediate: true,
            handler() {
                if (this.globalSiteSetting) {
                    this.selectedSiteId = this.$store.state.selectedSiteId;
                }
            }
        },
        selectedSiteId() {
            if (this.cart) {
                this.cart.site_id = this.selectedSiteId;
            }
        },
        onlyShowSites: {
            immediate: true,
            handler(sites) {
                if (this.globalSiteSetting) {
                    return;
                }
                if (sites && sites.length && !sites.includes(this.selectedSiteId)) {
                    this.selectedSiteId = sites[0];
                }
            }
        },
        showingProduct: {
            immediate: false,
            handler(showingProduct) {
                let id = showingProduct ? showingProduct.id : null;
                if (id != this.showProductId) {
                    this.setProp('showProductId', id);
                }
                let title = showingProduct ? makeValidPathFromTitle(showingProduct.name).substring(1) : null;
                if (title != this.showProductTitle) {
                    this.setProp('showProductTitle', title);
                }
            }
        },
        productsLoaded(loaded) {
            if (loaded) {
                if (this.showProductId) {
                    this.showingProduct = this.products.find(x => x.id == this.showProductId);
                } else if (this.showProductTitle) {
                    this.showingProduct = this.products.find(x => makeValidPathFromTitle(x.name).substring(1) == this.showProductTitle);
                }

                if (this.selectedCategoryId) {
                    let cat = this.allCategories.find(x => x.id == this.selectedCategoryId)
                    if (cat) {
                        this.selectedCategory = cat;
                    }
                } else if (this.selectedCategoryTitle) {
                    let cat = this.allCategories.find(x => {
                        let path = makeValidPathFromTitle(this.getCategoryPath(x)).substring(1);
                        if (path == this.selectedCategoryTitle) {
                            return true;
                        }
                    })
                    if (cat) {
                        this.selectedCategory = cat;
                    }
                }
            }
        },
        initialSortOrder: {
            immediate: true,
            handler(newSortOrder) {
                this.currentSortOrder = newSortOrder;
            }
        }
    },

    computed: {
        cart() {
            if (!this.products || !this.products.length) {
                return null;
            }

            if (!this.$store.state.carts || !this.$store.state.carts[this.cartName]) {
                return null;
            }

            return this.$store.state.carts[this.cartName];
        },
        cartItems() {
            if (!this.cart) {
                return [];
            }

            return this.cart.items.map(x => {
                let item = {};
                Object.assign(item, x);
                item.product = this.products.find(p => p.id == x.product_id);
                return item;
            });
        },
        checkoutItems() {
            let res = this.cartItems.map(carti => {
                return {product_id: carti.product.id, count: carti.count, variant: carti.variant, price: carti.price};
            });
            return res;
        },
        hasMultiSites() {
            return this.$store.state.settings?.sites?.length > 1;
        },
        selectedText() {
            if (this.searchQuery) {
                return this.$translate('Search results');
            }
            if (!this.selectedCategory || (this.topCategory && this.selectedCategory.name === this.topCategory.name)) {
                return this.$translate('Displaying the full range');
            }

            let categoryLevel = this.selectedCategory;
            const categoryLevels = [categoryLevel.name];
            while (categoryLevel.parent != this.topCategory) {
                categoryLevel = categoryLevel.parent;
                categoryLevels.push(categoryLevel.name);
            }

            const reversedLevels =  categoryLevels.reverse();

            return reversedLevels.join(', ');
        },
        categoryLevels() {
            function getCategoryLevels(categories, topCategory, selectedCategory, onlyShowCategories) {
                const categoryLevels = [];
                let currentParent = selectedCategory ? selectedCategory : topCategory;
                let previousParent = null;

                // eslint-disable-next-line no-constant-condition
                while (true) {
                    let categoryLevel = categories.filter(category => {
                        if (!category.parent && onlyShowCategories && onlyShowCategories.length > 1 && !onlyShowCategories.find((showCategory) => showCategory === category.id)) {
                            return false;
                        }
                        return category.parent == currentParent
                    });

                    categoryLevel = categoryLevel.map(category => {
                        return { id: category.id, name: category.name, selected: category === previousParent, parent: category.parent };
                    });

                    if (categoryLevel.length > 0) {
                        const sortedCategoryLevel = categoryLevel.sort((a, b) => {
                            return  a.name < b.name ? -1 : 1;
                        });
                        categoryLevels.push(sortedCategoryLevel);
                    }

                    if (currentParent == topCategory) {
                        break;
                    }

                    previousParent = currentParent;
                    currentParent = currentParent.parent;
                }

                return categoryLevels.reverse();
            }

            if (!this.allCategories || this.allCategories.length === 0) {
                return [];
            }

            return getCategoryLevels(this.allCategories, this.topCategory, this.selectedCategory, this.onlyShowCategories);
        },
        filteredProductsPerSite() {
            return this.getProductsForSite(this.selectedSiteId);
        },
        filteredProductsOnTopCategory() {
            const products = this.filteredProductsPerSite;

            if (!this.onlyShowCategories || this.onlyShowCategories.length === 0) {
                return products;
            }

            function getCategoryObject(allCategories, categoryId) {
                if (!allCategories) {
                    return null;
                }
                return allCategories.find(category => category.id === categoryId);
            }

            function findTopCategory(categoryObject, topCategoriesToInclude) {
                if (!categoryObject.parent) {
                    return topCategoriesToInclude.find(category => category === categoryObject.id);
                }

                return findTopCategory(categoryObject.parent, topCategoriesToInclude);
            }

            function includedInActiveCategory(product, allCategories, topCategoriesToInclude) {
                const productCategoryObject = getCategoryObject(allCategories, product.product_webshop_category_id);
                if (!productCategoryObject) {
                    return false;
                }
                return findTopCategory(productCategoryObject, topCategoriesToInclude)
            }

            function getFilteredProducts(products, allCategories, topCategoriesToInclude) {
                return products.filter((product) => includedInActiveCategory(product, allCategories, topCategoriesToInclude));
            }

            const filteredProducts = getFilteredProducts(products, this.allCategories, this.onlyShowCategories);

            return filteredProducts;
        },
        allCategories() {
            return this.$store.state.settings?.webshopcategories.filter(x => !x.removed);
        },
        topCategories() {
            return this.allCategories.filter(x => !x.parent_id);
        },
        availableTags() {
            let tags = [];
            this.filteredProductsPerSite.forEach(product => {
                if (product.tags) {
                    product.tags.forEach(tag => {
                        if (!tags.find(x => x.id === tag.id)) {
                            tags.push(tag);
                        }
                    });
                }
            });
            return tags.sort((a, b) => a.name.localeCompare(b.name));
        },
        filteredProducts() {
            let products = this.filteredProductsOnTopCategory;
            
            if (this.tagsFilter && this.tagsFilter.length) {
                products = products.filter(product => {
                    if (!product.tags || !product.tags.length) return false;
                    return product.tags.some(tag => this.tagsFilter.includes(tag.id));
                });
            }
            if (!this.selectedCategory) {
                return this.filterBySearchQuery(products);
            }

            function findInParentCategory(productCategory, category) {
                if (!productCategory) {
                    return false;
                }
                if (productCategory.id === category.id) {
                    return true;
                }
                if (!productCategory.parent) {
                    return false;
                }
                return findInParentCategory(productCategory.parent, category);
            }

            function getCategoryObject(allCategories, categoryId) {
                if (!allCategories) {
                    return null;
                }
                return allCategories.find(category => category.id === categoryId);
            }

            const productsToShow = products.filter((product) => {
                if (product.product_webshop_category_id === this.selectedCategory.id) {
                    return true;
                }
                const categoryObject = getCategoryObject(this.allCategories, this.selectedCategory.id);
                const productCategoryObject = getCategoryObject(this.allCategories, product.product_webshop_category_id);
                return findInParentCategory(productCategoryObject, categoryObject);
            });

            return this.filterBySearchQuery(productsToShow);
        },
        selectableSites() {
            if (!this.$store.state?.settings?.sites) {
                return [];
            }

            return this.$store.state.settings.sites.filter(site => {
                if (!this.onlyShowSites || this.onlyShowSites.length == 0) {
                    return true;
                }

                return this.onlyShowSites.includes(site.id);
            });
        },
        onlyShowOneSite() {
            return this.onlyShowSites?.length == 1;
        },
        topCategory() {
            if (this.onlyShowCategories && this.onlyShowCategories.length === 1) {
                return this.allCategories.find(category => category.id === this.onlyShowCategories[0]);
            } else if (this.topCategories && this.topCategories.length === 1) {
                return this.topCategories[0];
            }
            return null;
        },
        sortedProducts() {
            let sorted = [...this.filteredProducts];
            switch (this.currentSortOrder) {
                case 'name-asc':
                    sorted.sort((a, b) => (a.lowerCaseName.localeCompare(b.lowerCaseName, undefined, { numeric: true })));
                    break;
                case 'name-desc':
                    sorted.sort((a, b) => (b.lowerCaseName.localeCompare(a.lowerCaseName, undefined, { numeric: true })));
                    break;
                case 'price-asc':
                    sorted.sort((a, b) => a.price - b.price);
                    break;
                case 'price-desc':
                    sorted.sort((a, b) => b.price - a.price);
                    break;
                case 'stock-desc':
                    sorted.sort((a, b) => {
                        const aStock = a.stock === null ? Infinity : a.stock;
                        const bStock = b.stock === null ? Infinity : b.stock;
                        return bStock - aStock;
                    });
                    break;
                default:
                    sorted.sort((a, b) => a.id - b.id);
                    break;
            }
            return sorted;
        }
    },

    methods: {
        loadProducts() {
            this.$api.get('/api/public/trainingcard/type/get', {trial: true}).then(products => {
                this.products = products.filter(p => {
                    if (!p.customerCanBuy) {
                        return false;
                    }
                    if(p.type != 'course'){
                        p.lowerCaseName = p.name.toLowerCase();
                        return true;
                    }
                });
                this.productsLoaded = true;
            });
        },
        productDescription(html){
            if(html) {
                html = html.replace(/(<([^>]+)>)/gi, "");
                if(html.length>100) html = html.substr(0, 100).trim() + '…';
            }
            return html;
        },
        needsToChooseVariant(product) {
            return product.variants && product.variants.length && (product.variants.length > 1 || (product.variants[0].name != 'Standard' && product.variants[0].name));
        },
        buyClick(product) {
            if (this.forceInfoDialog || this.needsToChooseVariant(product) || product.payWhatYouWant) {
                this.productClick(product)
            } else {
                this.buy(product);
            }
        },
        productClick(product) {
            this.showingProduct = product;

            try {
                let ecommerceTrackingItem = {
                    id: 'p' + product.id,
                    name: product.name,
                    price: product.price,
                    vat: product.vat,
                };
                this.$ecommercetracking.viewItem(ecommerceTrackingItem);
            } catch(error) {
                Sentry.captureException(error);
            }
        },
        categorySelected(selected) {
            const selectedCategory = this.allCategories.find(category => category.id === selected.id);
            this.selectedCategory = selected.selected ? (selectedCategory.parent ? selectedCategory.parent : null) : selectedCategory;
            this.setProp('selectedCategoryId', this.selectedCategory ? this.selectedCategory.id : null)
            let title = this.selectedCategory ? makeValidPathFromTitle(this.getCategoryPath(this.selectedCategory)).substring(1) : null
            this.setProp('selectedCategoryTitle', title)
        },
        toggleTagFilter(tagId) {
            const filter = [...this.tagsFilter];
            const index = filter.indexOf(tagId);
            if (index >= 0) {
                filter.splice(index, 1);
            } else {
                filter.push(tagId);
            }
            this.setProp('tagsFilter', filter);
        },
        categoryLevelKey(categories) {
            const categoryNames = categories.map((category) => category.name);
            return categoryNames.join(', ');
        },
        buy(product) {
            this.addToCart({product});
        },
        addToCart({product, count, variant, price}) {
            count = count || 1;
            this.$store.dispatch('addToCart', {cartName: this.cartName, product_id: product.id, count, variant, price, site_id: this.selectedSiteId});
            this.$store.dispatch('setCartVisibility', {cartName: this.cartName, showBottomBar: true, showCheckout: false});
        },
        changeNumberOfItems(item, count) {
            this.$store.dispatch('changeItemCountInBasket', {basketName: this.cartName, product_id: item.product_id, variant: item.variant, count});
        },
        buyFromDialog({product, count, variant, price}) {
            this.addToCart({product, count, variant, price});
            this.showingProduct = null;
        },
        /* Returns a list of products in cart which are not available or are out of stock on specified site */
        getProductsMissingFromSite(site) {
            let products = this.getProductsForSite(site.id);
            let missing = this.cartItems.filter(item => {
                if (!products.find(p => p.id == item.product.id)) {
                    return true;
                }

                let stock = getStockForProduct(item.product, item.variant, site.id);
                if (stock === undefined || stock < item.count) {
                    return true;
                }

                return false;
            })

            return missing;
        },
        getProductsForSite(siteId) {
            let tcards = this.products;
            if (this.hasMultiSites) {
                return tcards.filter(x => {
                    if(x.type == 'membership') {
                        return true;
                    }
                    let isTrainingCard = x.type == 'trainingcard';
                    let prop = isTrainingCard ? 'sites' : 'visible_sites'
                    let sites = x[prop];
                    return !sites || sites.length == 0 || sites.includes(siteId)
                })
            } else {
                return tcards;
            }
        },
        setSite(site) {
            let missing = this.getProductsMissingFromSite(site);
            if (missing.length) {
                // Show confirm switch site-dialog
                this.switchSiteDialog.show = true;
                this.switchSiteDialog.fromSite = this.$store.state.settings.sites.find(x => x.id == this.selectedSiteId);
                this.switchSiteDialog.site = site;
                this.switchSiteDialog.missing = missing;
            } else {
                this.selectedSiteId = site.id;
            }
        },
        forceSetSite() {
            this.$store.dispatch('removeCart', {cartName: this.cartName});

            this.switchSiteDialog.missing.forEach(item => {
                this.$store.dispatch('changeItemCountInCart', {cartName: this.cartName, product_id: item.product_id, variant: item.variant, count: 0})
            })

            this.cart.site_id = this.switchSiteDialog.site.id;
        },
        clearCart() {
            this.$store.dispatch('removeBasket', {basketName: this.cartName})
        },
        getCategoryPath(cat) {
            let res = '';
            if (cat.parent) {
                res += this.getCategoryPath(cat.parent) + '-';
            }
            return res + cat.name;
        },
        isMembershipFrom0101(product) {
            return product.validFromDate.slice(5) == '01-01';
        },
        calculateAndFormatEndDate(date) {
            let dateObj = Date.newFull(date);
            dateObj.setDate(dateObj.getDate() - 1);
            return Date.formatFullShorter(dateObj);
        },
        filterBySearchQuery(products) {
            return this.searchQuery ? products.filter(product => product.lowerCaseName.includes(this.searchQuery)): products;
        }
    },
    mounted() {
        this.loadProducts();
        this.unsubscribe = this.$root.$api.subscribe({type: 'trainingcardtype', callback: () => this.loadProducts()})

        // When this component is shown - show bottom bar if cart has items
        let cart = this.$store.state.carts?.[this.cartName];
        if (cart && cart.items.length && !cart.showBottomBar && !cart.showCheckout) {
            this.$store.dispatch('setCartVisibility', {cartName: this.cartName, showBottomBar: true, showCheckout: false});
        }
    },
    destroyed() {
        this.unsubscribe?.();

        // When this component is hidden - hide bottom bar (leaving page)
        if (this.cart?.showBottomBar || this.cart?.showCheckout) {
            this.cart.showBottomBar = false;
            this.cart.showCheckout = false;
        }
    }
}
</script>
